export async function shouldEnableMocking() {
  if (import.meta.env.VITE_ENABLE_MSW === 'true') {
    const { worker } = await import('@/api/browser');

    await worker.start({
      onUnhandledRequest: 'bypass',
    });
  }
}
